module.exports = __webpack_public_path__ + "static/media/renaldio_pradipta_p.a07c080b.jpg";